import React from 'react'

export const Footer = () => {
    return (
        <div className='footer-spingo'>
            © {new Date().getFullYear()} SpinGo. Todos los derechos reservados.
        </div>
    )
}
